import $ from 'jquery';
import slick from 'slick-carousel';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Carousel {
    constructor(target, settings) {
        this.carouselContainer = target;
        this.settings = settings || {
            mobileFirst: true,
            arrows: false,
            dots: true,
            centermode: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        };
    }

    init() {
        $(this.carouselContainer).slick(this.settings);

		this.initCarousels();
        this.carouselWidget();
        this.iconCarouselWidget();
        this.resetIframes();
        this.attachImgEvents();
        this.fadeinRegister();
    }

    initCarousels() {
        const carousels = [
            { selector: '.carousel--big-ideas', hasVideos: false },
            { selector: '.carousel--videos', hasVideos: true },
            { selector: '.carousel--recipes', hasVideos: false },
            { selector: '.carousel--filters', hasVideos: false }
        ];

        carousels.forEach(({ selector, hasVideos }) => {
            $(selector).each((index, element) => {
                const $carousel = $(element);
                const carousel = element;
                const leftButton = $carousel.find('.carousel-btn-left').add($carousel.siblings('.carousel-btn-left'));
                const rightButton = $carousel.find('.carousel-btn-right').add($carousel.siblings('.carousel-btn-right'));
                const card = $carousel.find('.card');

                // 30px offset applies to more cases than a 10px offset, be aware that if this value gets
                // too high or the cards too narrow, it might not behave as expected
                this.checkForHorizontalOverflow($carousel, leftButton, rightButton, 30);
                $(window).on('resize', () => this.checkForHorizontalOverflow($carousel, leftButton, rightButton));

                leftButton.on('click', () => {
                    const maxScrollX = this.getMaxScrollX(carousel, card) + 20;
                    const currentScrollX = carousel.scrollLeft;
                    const newScrollX = Math.max(currentScrollX - maxScrollX, 0);
                    carousel.scrollTo({
                        left: newScrollX,
                        behavior: 'smooth'
                    });
                });

                rightButton.on('click', () => {
                    const maxScrollX = this.getMaxScrollX(carousel, card) + 20;
                    const currentScrollX = carousel.scrollLeft;
                    const newScrollX = Math.min(currentScrollX + maxScrollX, carousel.scrollWidth - carousel.clientWidth);
                    carousel.scrollTo({
                        left: newScrollX,
                        behavior: 'smooth'
                    });
                });

                $(selector).bind('scroll', (event) => {
                    if ($(selector).scrollLeft() > 0) {
                        leftButton.removeClass('hidden-carousel-btn');
                        leftButton.addClass('visible-carousel-btn');
                    } else {
                        leftButton.addClass('hidden-carousel-btn');
                        leftButton.removeClass('visible-carousel-btn');
                    }
                    const maxScrollX = this.getMaxScrollX(carousel, card) + 20;
                    const currentScrollX = carousel.scrollLeft;
                    const newScrollX = Math.min(currentScrollX + maxScrollX, carousel.scrollWidth - carousel.clientWidth);
                    if ((newScrollX - 3) <= $(selector).scrollLeft()) {
                        rightButton.removeClass('visible-carousel-btn');
                        rightButton.addClass('hidden-carousel-btn');
                    } else {
                        rightButton.removeClass('hidden-carousel-btn');
                        rightButton.addClass('visible-carousel-btn');
                    }
                });

                // Handle video reload if the carousel contains videos
                if (hasVideos) {
                    $('video').each((_, video) => video.load());
                }
            });
        });
    }

    checkForHorizontalOverflow(carousel, leftButton, rightButton, offset = 0) {
        if (carousel && leftButton && rightButton) {
            const nativeCarousel = carousel instanceof jQuery ? carousel[0] : carousel;
            // When a page starts loading, there's a slight difference of the scrollWidth,
            // around 1px - 8px, that disappears once the page has fully loaded, so the
            // option is given to set this offset in case this is called before the page
            // is fully loaded
            
            if (nativeCarousel.scrollWidth > nativeCarousel.clientWidth + offset) {
                leftButton.css('display', 'flex');
                rightButton.css('display', 'flex');
            } else {
                leftButton.css('display', 'none');
                rightButton.css('display', 'none');
            }
        }
    }

    getMaxScrollX(carousel, card) {
        return card ? card.width() : carousel.scrollWidth - carousel.clientWidth;
    }

    attachImgEvents() {
        let elements = $('.carousel-item');
        $(elements).on('click', (index, ele) => {
                setTimeout(() => {
                    let target = $('.carousel-img-modal .modal-img');
                    $(target).off('click');
                    $(target).on('click', (e) => {
                        $(e.currentTarget).toggleClass('big');
                    });
                }, 200);
        });
    }

    carouselWidget() {
		$('.slider-for').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
            fade: true,
            infinite: true,
			adaptiveHeight: true,
			asNavFor: '.slider-nav'
		});
		$('.slider-nav').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.slider-for',
			dots: false,
			infinite: true,
			arrows: true,
			focusOnSelect: true,
            mobileFirst: true,
            swipeToSlide: true,
		});

        $(window).on('load', () => {
            let carouselImgs = $('.carousel-item-img');
            $(carouselImgs).each((k, element) => {
                let elementModalId = $(element).data('modaal-content-source');
                let css = element.style.backgroundImage;
                let img = css.replace(/(?:^url\(["']?|["']?\)$)/g, '');
                let newImg = new Image();
                newImg.onload =  (e) => {
                   //console.log(this.naturalWidth); // This is the width you are looking for
                   //console.log(this.naturalHeight); // .. similarly the height.
                };
                newImg.src = img;
                if (newImg.width > newImg.height) {
                    if (!$(element).hasClass('is-landscape')) {
                        $(element).addClass('is-landscape');
                        $(elementModalId).find('.modal-img').addClass('is-landscape');
                    }
                } else if (newImg.width < newImg.height) {
                    if (!$(element).hasClass('is-landscape')) {
                        $(element).addClass('is-portrait');
                        $(elementModalId).find('.modal-img').addClass('is-portrait');
                    }
                }
            });
        });
	}

    iconCarouselWidget() {
        $('.slider-list').slick({
            arrows: true,
            fade: true,
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 540,
                settings: {
                    slidesPerRow: 1,
                    rows: 1,
                }
            }]
        });
    }

// this method is used to reset iframes that are playing on carousels on slide change
    resetIframes() {
        $(this.carouselContainer).on('afterChange', (event, slick, currentSlide, nextSlide) => {
            this.resetIframe();
        });
        $('.slider-for').on('afterChange', (event, slick, currentSlide, nextSlide) => {
            this.resetIframe();
        });
        $('.slider-nav').on('afterChange', (event, slick, currentSlide, nextSlide) => {
            this.resetIframe();
        });
    }

    resetIframe() {
        $('.carousel iframe').each((k, v) => {
            let elSrc = $(v).attr('src');
            $(v).attr('src', elSrc);
        });
    } 

    fadeinRegister() {
		if (!window.Launchpad.pageBuilderEditMode) {
			const elements = $('.js-entry');
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						this.handleLeftToRightAnimation();
						observer.unobserve(entry.target);
					}
				});
			});
			elements.each((i, e) => {
				observer.observe(e);
			});
		}
	}

    handleLeftToRightAnimation() {   
         setTimeout(() => {
			const anchorElements = document.querySelectorAll('.card-content-wrapper.ftl-animate');			

			// Add the 'fade-in-LtF' class to each element with a delay
			anchorElements.forEach((item, index) => {
				setTimeout(() => {
					item.classList.add('fade-in-LtF');
				}, index * 200); // Delay by 0.2 seconds per item
			});
		}, 1000);
    }
}

export default Carousel;

$(() => {
	const carousel = new Carousel();
	carousel.init();
});
